var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleGLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4815 9.19353C17.4815 8.58922 17.4273 8.00817 17.3265 7.45035H9.30017V10.7469H13.8867C13.6891 11.8122 13.0887 12.7147 12.1861 13.319V15.4574H14.9403C16.5518 13.9737 17.4815 11.7889 17.4815 9.19353Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30008 17.5219C11.6011 17.5219 13.5302 16.7588 14.9402 15.4572L12.186 13.3189C11.4229 13.8303 10.4467 14.1324 9.30008 14.1324C7.08043 14.1324 5.20167 12.6333 4.53152 10.6189H1.68433V12.827C3.08662 15.6122 5.96867 17.5219 9.30008 17.5219Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5316 10.6192C4.36116 10.1078 4.26431 9.56165 4.26431 8.99996C4.26431 8.43827 4.36116 7.89207 4.5316 7.38074V5.17271H1.68441C1.10722 6.32321 0.777954 7.62479 0.777954 8.99996C0.777954 10.3751 1.10722 11.6767 1.68441 12.8272L4.5316 10.6192Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30008 3.86716C10.5513 3.86716 11.6747 4.29714 12.5579 5.14162L15.0022 2.69729C13.5263 1.32212 11.5972 0.477646 9.30008 0.477646C5.96867 0.477646 3.08662 2.3874 1.68433 5.17261L4.53152 7.38063C5.20167 5.36629 7.08043 3.86716 9.30008 3.86716Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGLogo);
export default __webpack_public_path__ + "static/media/google_g_logo.34a23da3ff8dc1c49cf4282ed1996d4b.svg";
export { ForwardRef as ReactComponent };